// extracted by css-extract-rspack-plugin
export default {"icon":"src-modules-download-center-pages-DownloadCenterListPage-components-AppCard-AppCard-module__icon-IDnxZX","description":"src-modules-download-center-pages-DownloadCenterListPage-components-AppCard-AppCard-module__description-EYVLPu","platforms":"src-modules-download-center-pages-DownloadCenterListPage-components-AppCard-AppCard-module__platforms-bM_3yK","footer":"src-modules-download-center-pages-DownloadCenterListPage-components-AppCard-AppCard-module__footer-oKELyM"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"icon\":\"src-modules-download-center-pages-DownloadCenterListPage-components-AppCard-AppCard-module__icon-IDnxZX\",\"description\":\"src-modules-download-center-pages-DownloadCenterListPage-components-AppCard-AppCard-module__description-EYVLPu\",\"platforms\":\"src-modules-download-center-pages-DownloadCenterListPage-components-AppCard-AppCard-module__platforms-bM_3yK\",\"footer\":\"src-modules-download-center-pages-DownloadCenterListPage-components-AppCard-AppCard-module__footer-oKELyM\"}";
        // 1793873548912
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  